import { useContext } from 'react';
import { useStrategy } from '../../../hooks/useStrategy';
import TransparencyBarComponents from './TransparencyBarComponents';
import SegmentationFiltersInstanceContext from '../../../state/SegmentationFiltersInstanceContext';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { OrderedMap } from 'immutable';
import { isOperator } from 'customer-data-filters-ui/filterQueryFormat/operator/Operator';
import QuickFiltersValueDisplay from '../QuickFiltersValueDisplay';
import { QuickFiltersValueDisplayUses } from '../../../types/quickFilters/QuickFiltersValueDisplayUses';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TransparencyBarUI = () => {
  const {
    isLoadingViewerData,
    props: {
      baseFilterFamily
    },
    quickFiltersInternalValue
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFields
  } = useStrategy();
  const quickFiltersConditions = quickFiltersInternalValue ? quickFiltersInternalValue.conditions : OrderedMap();
  const allFields = getFields(baseFilterFamily);
  if (isLoadingViewerData || !allFields) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  const transparencyBarComponents = quickFiltersConditions.reduce((acc, condition) => {
    const filterFamily = quickFiltersInternalValue ? quickFiltersInternalValue.filterFamily : baseFilterFamily;
    if (!condition || !isOperator(condition) || !condition.field || !quickFiltersInternalValue) {
      return acc;
    }
    return [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    ...acc, /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        "data-selenium-test": `tb-component-${condition.field.name}`,
        marginInlineEnd: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          children: `${condition.field.label}: `
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        children: /*#__PURE__*/_jsx(QuickFiltersValueDisplay, {
          condition: condition,
          filterFamily: filterFamily,
          use: QuickFiltersValueDisplayUses.STRING
        })
      })]
    })];
  }, []);
  const hasTransparencyBarComponents = transparencyBarComponents.length > 0;
  if (!hasTransparencyBarComponents) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsx(TransparencyBarComponents, {
      transparencyBarComponents: transparencyBarComponents
    })
  });
};
export default TransparencyBarUI;